$(function() {

    $.commerce = {};

    $.commerce.delayFadeOut = ($("#commerce-container").next('section').hasClass('profile-section')) ? false : true;

    $.commerce.lastProfile = false;

    // durations

    $.commerce.duration = '75%';

    $.commerce.calculatePinDuration = function() {
        var contentHeight = $('#commerce-container .content-container').outerHeight();
        if ($.commerce.lastProfile) {
            $.commerce.pinDuration = 0;
        } else {
            $.commerce.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.commerce.pinDuration;
	};

    $.commerce.zoomDuration = '100%';

    $.commerce.endDuration = ($.commerce.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.commerce.tl = {};

    // in

	$.commerce.tl.in = new TimelineMax();

    $.commerce.tl.in.addLabel("start");

    $.commerce.tl.in.set("#commerce-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.commerce.tl.in.from("#commerce-svg .line-1", 1, { x:"2560" }, "start");
        $.commerce.tl.in.from("#commerce-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.commerce.tl.in.from("#commerce-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.commerce.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#commerce-in', triggerHook: 'onEnter', duration: $.commerce.duration })
        	.setTween($.commerce.tl.in)
        	// .addIndicators({name: 'commerce in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#commerce-pin', triggerHook: 'onLeave', duration: $.commerce.calculatePinDuration })
        .setPin('#commerce-container .svg-background')
        // .addIndicators({name: 'commerce pin'})
        .addTo($.controller);

    // zoom

    $.commerce.zoom = {};

    $.commerce.tl.zoom = new TimelineMax();

    $.commerce.tl.zoom.addLabel("start");
    $.commerce.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.commerce.tl.zoom.to("#commerce-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.commerce.zoom.scale = 10;
        $.commerce.zoom.offset = $.commerce.zoom.scale * 100 / 2;
        $.commerce.zoom.xy = "-"+ $.commerce.zoom.offset +"%";

        $.commerce.tl.zoom.to("#commerce-svg .svg-text", 2, { x:$.commerce.zoom.xy, y:$.commerce.zoom.xy, scaleX:$.commerce.zoom.scale, scaleY:$.commerce.zoom.scale, force3D:true }, "start");

    }

    $.commerce.tl.zoom.to("#commerce-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.commerce.tl.zoom.to("#commerce-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.commerce.tl.zoom.fromTo("#commerce-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.commerce.tl.zoom.set("#commerce-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.commerce.tl.zoom.set("#commerce-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.commerce.tl.zoom.fromTo("#commerce-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.commerce.tl.zoom.fromTo("#commerce-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.commerce.tl.zoom.fromTo("#commerce-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.commerce.tl.zoom.fromTo("#commerce-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#commerce-zoom', triggerHook: 'onCenter', duration: $.commerce.zoomDuration })
        .on('start', function () {
            $.commerce.tl.in.seek($.commerce.tl.in.duration(), false);
        })
        .setTween($.commerce.tl.zoom)
        // .addIndicators({name: 'commerce zoom'})
        .addTo($.controller);

    $.commerce.tl.out = new TimelineMax();

    $.commerce.tl.out.addLabel("start");

    $.commerce.tl.out.to("#commerce-container .content-container", 1, { opacity:0 }, "start");

    if ($.commerce.delayFadeOut) {
        $.commerce.tl.out.to("#commerce-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.commerce.tl.out.to("#commerce-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#commerce-end', triggerHook: 'onCenter', duration: $.commerce.endDuration })
        .setTween($.commerce.tl.out)
        // .addIndicators({name: 'commerce out'})
        .addTo($.controller);

});
